import { NetworkError } from '@/api/errors'
import {
  AuthApi,
  BeepersApi,
  CatalogsApi,
  ConfigApi,
  Configuration,
  CouriersApi,
  CustomersApi,
  DevicesApi,
  EmployeesApi,
  ErrorMessagesApi,
  FloorplansApi,
  InternalBillingApi,
  LegalEntitiesApi,
  PaymentsApi,
  PrintersApi,
  ReportsApi,
  ReservationsApi,
  TabsApi,
  VersionsApi
} from '@/openapi'
import { useAuthStore } from '@/store/auth'
import { useConfigStore } from '@/store/config'

const configuration = new Configuration({
  basePath: `${import.meta.env.VITE_APP_BASE_URL}/pos`,
  middleware: [
    {
      pre: async ctx => {
        const auth = useAuthStore()
        const configStore = useConfigStore()
        const headers: Record<string, string> = {}

        if (auth.accessToken) {
          headers['Authorization'] = auth.accessToken
        }

        const locationId = auth.locationId
        if (locationId) {
          headers['Location-ID'] = locationId
        }

        const organizationId = auth.organizationId
        if (organizationId) {
          headers['Organization-ID'] = organizationId
        }

        const employeeId = auth.currentEmployeeId
        if (employeeId) {
          headers['Employee-ID'] = employeeId
        }

        const deviceId = configStore.device.id
        if (deviceId) {
          headers['Device-ID'] = deviceId
        }

        const appVersion = configStore.appVersion
        if (appVersion) {
          headers['App-Version'] = appVersion
        }

        ctx.init.headers = {
          ...ctx.init.headers,
          ...headers
        }

        return ctx
      },
      post: async ctx => {
        if (ctx.response.status === 401) {
          const auth = useAuthStore()
          await auth.logout()
        }
        return ctx.response
      }
    },
    {
      onError: ctx => {
        const message =
          ctx.error && typeof ctx.error === 'object' && 'message' in ctx.error
            ? (ctx.error.message as string)
            : typeof ctx.error === 'string'
              ? (ctx.error as string)
              : ''

        if (message.includes('Failed to fetch') || message.includes('Load failed')) {
          throw new NetworkError('No internet connection')
        }
        throw ctx.error
      }
    }
  ]
})

export const customersApi = new CustomersApi(configuration)
export const couriersApi = new CouriersApi(configuration)
export const authApi = new AuthApi(configuration)
export const reservationsApi = new ReservationsApi(configuration)
export const catalogsAPI = new CatalogsApi(configuration)
export const employeesApi = new EmployeesApi(configuration)
export const reportsApi = new ReportsApi(configuration)
export const floorplansApi = new FloorplansApi(configuration)
export const paymentsApi = new PaymentsApi(configuration)
export const internalBillingApi = new InternalBillingApi(configuration)
export const configApi = new ConfigApi(configuration)
export const versionApi = new VersionsApi(configuration)
export const beepersApi = new BeepersApi(configuration)
export const errorMessagesApi = new ErrorMessagesApi(configuration)
export const printersApi = new PrintersApi(configuration)
export const devicesApi = new DevicesApi(configuration)
export const legalEntitiesApi = new LegalEntitiesApi(configuration)
export const tabsApi = new TabsApi(configuration)
